const DirectionEnum = {
  Long : 'Long',
  Short: 'Short'
}

export default DirectionEnum
